import React from 'react';

/**
 * The card that follows the pointer during a drag.
 * Rendered once at the app root and positioned with fixed coordinates so it
 * can float above every day column.
 */
export default function DragGhost({ drag }) {
  if (!drag) return null;

  return (
    <div
      className="sheet torn pointer-events-none fixed z-50 flex items-center px-3 py-2 shadow-paper-lift"
      style={{
        left: drag.left,
        top: drag.top,
        width: drag.size.width,
        transform: 'rotate(-2deg)', // slight tilt: it looks like a lifted sticky note
      }}
    >
      <span className="truncate font-hand text-lg leading-tight">{drag.payload.habit.name}</span>
    </div>
  );
}
